import React from 'react';
import * as stylex from '@stylexjs/stylex';
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import VoucherCampaignEditor from "src/routes/orgs/membership/vouchers/campaigns/VoucherCampaignEditor";
import VoucherCampaigns from "src/routes/orgs/membership/vouchers/campaigns/VoucherCampaigns";
import VoucherCampaignViewer from "src/routes/orgs/membership/vouchers/campaigns/VoucherCampainViewer";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { useModalContext } from "nood-comp/src/comp/modal/NoodleModalProvider";
import { useNavigate } from "react-router-dom";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
export default function VoucherCampaignIndex(props) {
  var id = useURLParam("id");
  var mod = useModalContext();
  var navigate = useNavigate();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Campaigns"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "list",
    menuItems: [{
      id: "list",
      icon: "menu",
      content: /*#__PURE__*/React.createElement(VoucherCampaigns, null),
      label: "Campaigns",
      queryString: {
        id: undefined
      }
    }, {
      id: "new",
      icon: "plus",
      content: /*#__PURE__*/React.createElement(VoucherCampaignEditor, null),
      label: "New",
      queryString: {
        id: undefined
      }
    }, {
      id: "view",
      icon: "eye",
      content: /*#__PURE__*/React.createElement(VoucherCampaignViewer, null),
      label: "View",
      queryString: {
        "do": "view",
        id: id
      },
      show: !!id
    }, {
      id: "edit",
      icon: "edit-2",
      content: /*#__PURE__*/React.createElement(VoucherCampaignEditor, null),
      label: "Edit",
      queryString: {
        id: id,
        "do": "edit"
      },
      show: !!id
    }, {
      id: "delete",
      icon: "trash-2",
      __click: function __click() {
        mod.__confirmDelete({
          entity: "Voucher Campaign",
          endpoint: "/voucher-campaign/".concat(id),
          __onAfterDelete: function __onAfterDelete(res) {
            navigate(queryStringMod({
              "do": "list",
              id: undefined
            }));
          }
        });
      },
      show: !!id,
      label: "Delete"
    }]
  }));
}

// @ts-ignore